import { defineComponent as _defineComponent } from 'vue'
import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7820b39f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "checkout-service-point__top-container" }
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = { class: "checkout-service-point__header" }
const _hoisted_5 = { class: "checkout-service-point__text" }
const _hoisted_6 = { class: "checkout-service-point__text" }

import { computed, PropType, ref, watch } from "vue";
import { Uuid } from "@/code/Uuid";
import { IServicePoint } from "@/models/IServicePoint";
import { IServicePointOpeningHour } from "@/models/IServicePointOpeningHour";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCheckoutServicePoint',
  props: {
  servicePoint: {
    type: Object as PropType<IServicePoint>,
    required: true,
  },
  model: {
    type: Object as PropType<IServicePoint>,
    required: true,
  },
},
  emits: {
  change: (servicePoint: IServicePoint) => true,
},
  setup(__props, { emit }) {

const props = __props;

const id = ref<string>(Uuid.newUuid());

const model = ref<IServicePoint>(props.model);
watch(
  () => props.model,
  (currVal) => {
    model.value = currVal;
  }
);
const address = computed(() => {
  const street = props.servicePoint?.visitingAddress?.streetName + (props.servicePoint?.visitingAddress?.streetNumber ? ` ${props.servicePoint?.visitingAddress?.streetNumber}` : '');

  return `${street}, ${props.servicePoint?.visitingAddress?.postalCode} ${props.servicePoint?.visitingAddress?.city}`;
});
const openingHourAsString = (openingHour: IServicePointOpeningHour) => {
  let sb = openingHour.fromDay;
  if (openingHour.toDay) {
    sb += `-${openingHour.toDay}`;
  }
  sb += ` ${openingHour.from}`;
  if (openingHour.to) {
    sb += `-${openingHour.to}`;
  }
  return sb;
};

const onChange = (ev) => {
  emit("change", props.servicePoint);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    for: id.value,
    class: _normalizeClass(["checkout-service-point", { 'checkout-service-point--active': model.value == __props.servicePoint }])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: id.value,
        value: __props.servicePoint,
        class: "radio-input checkout-service-point__input",
        name: "service-point",
        type: "radio",
        onChange: onChange,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
      }, null, 40, _hoisted_3), [
        [_vModelRadio, model.value]
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.servicePoint.name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(address.value), 1),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.servicePoint.openingHours, (openingHour) => {
        return (_openBlock(), _createElementBlock("li", {
          key: openingHour.from
        }, _toDisplayString(openingHourAsString(openingHour)), 1))
      }), 128))
    ])
  ], 10, _hoisted_1))
}
}

})